var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPredictiveModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FFF7E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.9674H6.66555C6.71988 16.8203 7.06813 15.7501 7.63656 14.8305L6.67578 13.5606L5.14004 13.3276C4.4123 14.7144 4 16.2926 4 17.9674V17.9674Z",
    fill: "#EB6671"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14062 13.3278L7.63711 14.8307C8.33539 13.7009 9.36605 12.7983 10.5927 12.2594L9.99668 10.4944L8.62723 9.53271C7.15961 10.4696 5.95332 11.7792 5.14062 13.3278Z",
    fill: "#F38C6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8102 18.2211C15.8102 19.2215 14.9992 20.0324 13.9988 20.0324C12.9984 20.0324 12.1875 19.2215 12.1875 18.2211C12.1875 17.2207 13.9988 12.5938 13.9988 12.5938C13.9988 12.5938 15.8102 17.2207 15.8102 18.2211Z",
    fill: "#EB6671"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8113 18.2211C15.8113 19.2215 15.0004 20.0324 14 20.0324V12.5938C14 12.5938 15.8113 17.2207 15.8113 18.2211Z",
    fill: "#D96383"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5398 8.08574L15.8098 10.26L14.6984 11.8705C14.4695 11.8186 14.2359 11.7783 13.9984 11.7506C13.7477 11.7217 13.4922 11.7064 13.2336 11.7064C12.2934 11.7064 11.3996 11.9041 10.5906 12.2592L8.625 9.53262C10.177 8.54199 12.0207 7.96777 13.9984 7.96777C14.5227 7.96777 15.0375 8.00801 15.5398 8.08574Z",
    fill: "#FFDE86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5405 8.08594L14.6992 11.8706C16.1334 12.1969 17.3895 12.9917 18.2975 14.0858L20.5225 13.3279L21.4005 11.2431C19.8982 9.59043 17.8498 8.4432 15.5405 8.08594Z",
    fill: "#C3D785"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9984 17.9677C23.9984 15.3785 23.0143 13.0191 21.3998 11.2432L18.2969 14.0859C19.1795 15.1493 19.7336 16.4951 19.8033 17.9677H23.9984Z",
    fill: "#87D4A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5414 8.08574L14.7 11.8705C14.4711 11.8186 14.2375 11.7783 14 11.7506V7.96777C14.5242 7.96777 15.0391 8.00801 15.5414 8.08574Z",
    fill: "#E4BE41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictiveModel);
export default __webpack_public_path__ + "static/media/predictiveModel.72bdefa9cc32e139b83b2b3174fee21d.svg";
export { ForwardRef as ReactComponent };